export const FETCH_FOLLOW_UP_EMAIL_DATA = "FETCH_FOLLOW_UP_EMAIL_DATA";
